<template>
  <v-item-group
    v-model="internalValue"
    :mandatory="mandatory"
  >
    <v-row :dense="dense">
      <v-col
        v-for="item in items"
        :key="item.value"
      >
        <v-item
          v-slot="{ active, toggle }"
          :value="item.value"
        >
          <v-btn
            block
            :color="active ? 'primary' : 'grey'"
            :text="!active"
            :class="buttonClass"
            class="pa-0"
            elevation="0"
            @click="toggle"
          >
            {{ item.text }}
          </v-btn>
        </v-item>
      </v-col>
    </v-row>
  </v-item-group>
</template>

<script>
export default {
  name: 'ButtonGroup',
  props: {
    mandatory: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      required: true
    },
    dense: {
      type: Boolean,
      default: false
    },
    buttonClass: {
      type: [Object, String],
      default: undefined
    },
    value: {
      type: [String, Number, Boolean, Array],
      default: undefined
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style scoped>

</style>
